<template>
  <v-dialog
    v-model="companyAddressFilter"
    @submit="applyFilters()"
    @reset="resetFilters()"
    width="30%"
    ><v-card>
      <v-card-title>
        <v-row class="d-flex justify-space-between">
          <v-col cols="6">
            <h3 class="text-body-1 primary--text font-weight-bold">
              Organization Location Filter
            </h3>
          </v-col>
          <v-col cols="6" class="d-flex justify-end">
            <v-icon @click="companyAddressFilter = false" color="primary"
              >mdi-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-4">
        <v-form ref="companyAddressFilterForm">
          <v-row no-gutters>
            <v-col cols="12" md="6" lg="6" xl="6" class="">
              <BaseSelect
                dense
                hide-details
                outlined
                clearable
                label="Select Organization"
                :itemsList="companyList"
                itemText="name"
                itemValue="value"
                :multiple="true"
                v-model="filters.company_id"
                class="pl-1"
                :menu-props="{ offsetY: true }"
                @change="syncCompanyAddressFilters('company_id', $event)"
              ></BaseSelect>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions class="d-flex justify-end">
        <BaseSecondaryButton
          small
          customClass="rounded-lg"
          id="resetCompanyAddressFilter"
          @click="resetFilters()"
          >Reset</BaseSecondaryButton
        >
        <BaseButton
          small
          customClass="rounded-lg"
          id="applyCompanyAddressFilter"
          @click="applyFilters()"
          >Apply</BaseButton
        >
      </v-card-actions>
    </v-card></v-dialog
  >
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      companyList: [],
      filters: {},
    };
  },
  watch: {
    companyAddressFilter(value) {
      if (value) {
        this.getCompanyList();
        let filters = localStorage.getItem("companyLocationFilters");
        if (!filters) {
          filters = {};
        }
        if (typeof filters == typeof "string") {
          filters = JSON.parse(filters);
        }
        this.filters = filters;
      }
    },
  },
  computed: {
    companyAddressFilter: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    getCompanyList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      this.$api.company.getCompanyList(params).then((res) => {
        this.companyList = res.data.map((obj) => {
          return {
            name: obj.name,
            value: obj.company_id,
          };
        });
      });
    },
    syncCompanyAddressFilters(key, value) {
      let filters = localStorage.getItem("companyLocationFilters");
      if (!filters) {
        filters = {};
      }
      if (typeof filters == typeof "string") {
        filters = JSON.parse(filters);
      }
      if (value !== null && value.length > 0) {
        filters[key] = value;
      } else {
        delete filters[key];
      }
      this.filters = filters;
      localStorage.setItem("companyLocationFilters", JSON.stringify(filters));
    },
    applyFilters(reload) {
      this.$emit("companyAddressFiltersChanged");
      this.companyAddressFilter = false;
    },
    resetFilters(reload) {
      this.filters = {};
      localStorage.removeItem("companyLocationFilters");
      this.$emit("companyAddressFiltersChanged");
      if (this.$refs.companyAddressFilterForm) {
        this.$refs.companyAddressFilterForm.reset();
      }
    },
  },
};
</script>

<style>
</style>